$(document).ready(function () {
    //HEADER DROPDOWN SCRIPT START
    $('.header .navbar-nav .dropdown').hover(function (e) {
        $(this).addClass('dropdown-menu-show');
        var eleOffset = $('.dropdown-submenu-item').offset();
        $(".dropdown-item-list").find('.dropdown-menu').css({
            "position": "fixed",
            "top": eleOffset.top + 'px',
            "left": eleOffset.left + $(this).width() + 'px'
        });
    }, function () {
        $(this).removeClass('dropdown-menu-show');
    });
    //HEADER DROPDOWN SCRIPT END
    //DROPDOWN KEEP OPEN SCRIPT START
    $('.dropdown-menu.keep-open,.export-dropdown .dropdown-menu').on('click', function (e) {
        e.stopPropagation();
    });
    //DROPDOWN KEEP OPEN SCRIPT END
});
